<app-splash-screen></app-splash-screen>

<ion-app>
  <ion-header></ion-header>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<!--<pre style="width: 100%; border: 2px solid tomato; position: fixed; background: white; z-index: 100; bottom: 0; max-height: 400px; overflow: auto; padding: 50px;">{{-->
<!--    stringifyJSONRecursive(appStateService.state)-->
<!--}}</pre>-->
